import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  private readonly deleteSessionSubject = new Subject<string>();
  deleteSession$ = this.deleteSessionSubject.asObservable();

  requestDeleteSession(id: string) {
    this.deleteSessionSubject.next(id);
  }
}
